// services/passwordResetService.ts

// ✅ CORREGIDO: Usar solo la base URL, no incluir el path específico
const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080';

export const passwordResetService = {
  /**
   * Solicitar restablecimiento de contraseña
   */
  requestPasswordReset: async (email: string) => {
    // ✅ CORREGIDO: Construir URL completa correctamente
    const response = await fetch(`${API_BASE_URL}/api/password-reset/request`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      throw new Error('Error al procesar la solicitud');
    }

    return response.json();
  },

  /**
   * Validar token de restablecimiento
   */
  validateResetToken: async (token: string) => {
    const response = await fetch(`${API_BASE_URL}/api/password-reset/validate/${token}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al validar el token');
    }

    return response.json();
  },

  /**
   * Restablecer contraseña
   */
  resetPassword: async (token: string, newPassword: string, confirmPassword: string) => {
    const response = await fetch(`${API_BASE_URL}/api/password-reset/reset`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token,
        newPassword,
        confirmPassword,
      }),
    });

    const data = await response.json();
    
    return {
      ok: response.ok,
      status: response.status,
      data,
    };
  },
};